import router from "../router"
export default function loginout () {
  window.localStorage.clear()
  // 跳转到首页
  this.headerShow = false
  router.push('/')
  // window.location.reload()

  //  return  window.location.href = "./login";

}



//////////////////
// WEBPACK FOOTER
// ./src/directives/loginout.js
// module id = RHmf
// module chunks = 41